import { BackendModule } from 'i18next';
import { Locale } from 'ggApp/types/common';

import { Namespace, Translations } from './types';

const importKeys = ({
    locale,
    namespace,
}: {
    locale: Locale;
    namespace: Namespace;
}): Promise<Translations> => {
    if (namespace in Namespace) {
        return import(
            /* webpackChunkName: "i18n-translation-keys[index]" */ `../${namespace}/keys/${locale}.json`
        );
    }

    throw new Error(`Path was not set for namespace "${namespace}"`);
};

const i18nextBackend: BackendModule = {
    type: 'backend',
    init: () => {},
    read: (locale: Locale, namespace: Namespace, callback) => {
        if (!Object.values(Namespace).includes(namespace)) {
            callback(new Error(`Namespace "${namespace}" is not supported`), null);
            return;
        }

        if (!Object.values(Locale).includes(locale)) {
            callback(new Error(`Locale "${locale}" is not supported`), null);
            return;
        }

        importKeys({ locale, namespace })
            .then((result) => {
                callback(null, result);
            })
            .catch((error) => {
                callback(error, null);
            });
    },
};

export default i18nextBackend;
